<div class="account-verified-layout">
  <img alt="imagedetails" src="assets/images/login-registration/registration-logo.svg" class="logo" />
  <div class="account-verified-container">
    @if (isLoaded) {
      <h5 class="account-verified-title">{{ 'account.verified.title' | translate }}</h5>
      @if (isError) {
        <p class="account-verified-message" [innerHTML]="'account.verified.error.message' | translate | markdownTranslate"></p>
      } @else {
        <h6 class="account-verified-subtitle">{{ 'account.verified.subtitle' | translate }}</h6>
        <p class="account-verified-message" [innerHTML]="'account.verified.message' | translate | markdownTranslate"></p>
      }
      <div class="action-wrapper">
        <button class="submit-btn btn btn-success fw-bold" (click)="back()">
          {{ 'account.verified.page.back.to.login.button' | translate }}
        </button>
      </div>
    } @else {
      <div class="loading-container">
        <fgbcl-loading [color]="'#333834'"></fgbcl-loading>
      </div>
    }
  </div>
</div>
